export interface SearchRequest {
  text: string;
  content: boolean;
  questionChain: boolean;
  maxResult: number;
}

export interface SearchResponse {
  content: Array<any>;
  questionChain: Array<any>;
  tiplist: Array<any>;
}

export interface LocalisedText {
  [language: string]: string;
}

export interface SearchResponseCont {
  _id: string;
  state: number;
  title: LocalisedText;
  description: LocalisedText;
  keywords?: LocalisedText;
}

export interface SearchResponseQuest {
  _id: string;
  question_id: string;
  title: LocalisedText;
  description: LocalisedText;
  keywords?: LocalisedText;
}

export interface Tip {
  _id: string;
  text: LocalisedText;
  title: string;
}

interface Tiplist {
  _id: string;
  keywords?: LocalisedText;
  title: string;
  tips: Array<Tip>;
}

export interface SearchResponseTiplist {
  _id: string; // id of questionchain
  tiplist: Tiplist;
}